// Centralized auth utilities to avoid duplication

import { User } from "@/types/auth";

export const AUTH_STORAGE_KEYS = {
  USER: 'user',
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
} as const;

export function clearAuthStorage(): void {
  localStorage.removeItem(AUTH_STORAGE_KEYS.USER);
  localStorage.removeItem(AUTH_STORAGE_KEYS.ACCESS_TOKEN);
  //localStorage.removeItem(AUTH_STORAGE_KEYS.REFRESH_TOKEN);
}

export function getStoredAuth() {
  const user = localStorage.getItem(AUTH_STORAGE_KEYS.USER);
  const accessToken = localStorage.getItem(AUTH_STORAGE_KEYS.ACCESS_TOKEN);
  const refreshToken = localStorage.getItem(AUTH_STORAGE_KEYS.REFRESH_TOKEN);

  return { user, accessToken, refreshToken };
}

export function setAuthStorage(data: {
  user: string;
  accessToken: string;
  refreshToken: string;
}): void {
  localStorage.setItem(AUTH_STORAGE_KEYS.USER, data.user);
  localStorage.setItem(AUTH_STORAGE_KEYS.ACCESS_TOKEN, data.accessToken);
  localStorage.setItem(AUTH_STORAGE_KEYS.REFRESH_TOKEN, data.refreshToken);
}

function normalizeApiVersion(version: string): string {
  const trimmed = version.replace(/\/+$/, '');
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}

export function getApiUrl(endpoint: string = ''): string {
  const runtimeConfig = (window as { APP_CONFIG?: { API_BASE_URL?: string; API_VERSION?: string } }).APP_CONFIG;

  const apiVersion = normalizeApiVersion(
    runtimeConfig?.API_VERSION ??
      import.meta.env.VITE_API_VERSION ??
      '/api/v2'
  );

  const cleanEndpoint = endpoint.replace(/^\/+/, '');
  const join = (base: string) =>
    cleanEndpoint ? `${base}/${cleanEndpoint}` : base;

  if (import.meta.env.DEV) {
    const baseUrl = (
      runtimeConfig?.API_BASE_URL ??
      import.meta.env.VITE_API_BASE_URL ??
      'http://localhost:8089'
    ).replace(/\/+$/, '');
    return join(`${baseUrl}${apiVersion}`);
  }

  return join(apiVersion);
}

export function getAbsoluteApiUrl(endpoint: string = ''): string {
  const url = getApiUrl(endpoint);
  if (url.startsWith('http')) return url;
  return `${window.location.origin}${url}`;
}

export function getAuthUser(): User | null {
  const user = localStorage.getItem(AUTH_STORAGE_KEYS.USER);
  return user ? JSON.parse(user) : null;
}
